import { z } from 'zod';

export const INBOX_LIMITS = { page: 50, id: 200, title: 140, body: 600 } as const;
export const InboxIdSchema = z.string().regex(/^[a-zA-Z0-9_-]+$/).max(INBOX_LIMITS.id);
export const InboxEventSchema = z.object({
  id: InboxIdSchema,
  type: z.enum(['booking', 'pack', 'payment', 'refund', 'suggestion']),
  title: z.string().min(1).max(INBOX_LIMITS.title),
  body: z.string().min(1).max(INBOX_LIMITS.body),
  createdAt: z.string().datetime(), readAt: z.string().datetime().nullable(),
  version: z.number().int().positive(),
  businessId: InboxIdSchema.optional(),
  bookingId: InboxIdSchema.optional(), checkoutId: InboxIdSchema.optional(), subscriptionId: InboxIdSchema.optional(),
}).strict();
export const InboxPageSchema = z.object({ data: z.array(InboxEventSchema).max(INBOX_LIMITS.page), nextCursor: z.string().max(250).optional() }).strict();
export const InboxReadSchema = z.object({ expectedVersion: z.number().int().positive() }).strict();
export const PushRegistrationSchema = z.object({
  expoPushToken: z.string().regex(/^(ExponentPushToken|ExpoPushToken)\[[a-zA-Z0-9_-]{10,200}\]$/),
  platform: z.enum(['ios', 'android']), deviceId: z.string().min(1).max(200),
  permission: z.literal('granted'), revision: z.number().int().positive().max(Number.MAX_SAFE_INTEGER),
}).strict();
export const PushRevocationSchema = z.object({ revision: z.number().int().positive().max(Number.MAX_SAFE_INTEGER) }).strict();
export const PushRegistrationResultSchema = z.object({ status: z.literal('registered') }).strict();
export type InboxEvent = z.infer<typeof InboxEventSchema>;
export type InboxPage = z.infer<typeof InboxPageSchema>;
export type PushRegistration = z.infer<typeof PushRegistrationSchema>;
